import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import Container from '../components/Container';
import Heading2 from '../components/Heading2';

const EnterZipCodeScreen: React.FC = () => {
  const userContext = useContext(UserContext);
  const [zipcode, setZipcode] = useState(userContext?.userData.zipcode || '');
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext) {
      const { zipcode } = userContext.userData;
      setZipcode(zipcode);
    }
  }, [userContext]);

  if (!userContext) return null;

  const { userData, setUserData } = userContext;

  const handleNext = async () => {
    setUserData({ ...userData, zipcode });
    navigate('/choose-service');
  };

  return (
    <Container>
      <Heading2>What's Your ZIP Code?</Heading2>
      <p className="text-gray-700 mb-6 text-center">
        Remember: Skin Clique providers come to you, so we'll search for a provider with availability in your area based
        on the ZIP Code you enter.
      </p>

      <div className="relative mb-6">
        <div className="flex items-center border-b-2 border-black py-[.5rem]">
          <span className="absolute left-0 flex items-center pl-0 text-gray-500">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="h-5 w-5" />
          </span>
          <input
            type="text"
            value={zipcode}
            onChange={(e) => setZipcode(e.target.value)}
            className="w-full appearance-none px-3 py-2 pl-7 leading-tight text-gray-700 focus:outline-none"
            placeholder="ZIPCODE"
          />
          <button
            onClick={handleNext}
            disabled={false}
            className="pointer-events-auto rounded-[15px] border border-solid border-[#1b1a30] px-[.75rem] py-[.4rem] font-normal leading-5 text-[#1b1a30] shadow-[3px_4px_0_0_#1b1a30] hover:text-[#f4f2f1] hover:border-[#f4f2f1] hover:bg-[#1b1a30] active:shadow-none font-[nimbus-sans-extended,sans-serif] uppercase  transition-shadow duration-200 text-sm"
          >
            Search
          </button>
        </div>
      </div>
    </Container>
  );
};

export default EnterZipCodeScreen;
